import React, { useEffect } from 'react';
import DocumentationSidebar from '../component/DocumentationSidebar';
import Searchbar from '../component/SearchBar';
import image001 from '../assetes/images/survey/create-survey-img/image001.png';
import image002 from '../assetes/images/survey/create-survey-img/image002.png';
import image003 from '../assetes/images/survey/create-survey-img/image003.png';
import image004 from '../assetes/images/survey/create-survey-img/image004.png';
import image005 from '../assetes/images/survey/create-survey-img/image005.png';
import image006 from '../assetes/images/survey/create-survey-img/image006.png';
import image007 from '../assetes/images/survey/create-survey-img/image007.png';
import image008 from '../assetes/images/survey/create-survey-img/image008.png';
import image009 from '../assetes/images/survey/create-survey-img/image009.png';
import image010 from '../assetes/images/survey/create-survey-img/image010.png';
import image011 from '../assetes/images/survey/create-survey-img/image011.png';
import image012 from '../assetes/images/survey/create-survey-img/image012.png';
import image013 from '../assetes/images/survey/create-survey-img/image013.png';
import image014 from '../assetes/images/survey/create-survey-img/image014.png';
import image015 from '../assetes/images/survey/create-survey-img/image015.png';
import image016 from '../assetes/images/survey/create-survey-img/image016.png';

export default function CreateCalculator() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className='d-flex flex-column main-outer-wrapper'>
        <div className="flex-grow-1 d-flex survey-main-wrapper">
          <DocumentationSidebar />

          {/* Dashboard Content */}
          <div className="flex-grow-1 dashboard-page-outer">
            <div className='dashboard-page-wrap document-page-wrap'>
              <Searchbar containerSelector=".search-scope" />
              <div className='search-scope mt-4'>
                <h1 className='mt-0 text-primary'>Create ROI Calculator</h1>
                <p className='header-para'>
                  This screen allows users to configure a new ROI (Return on Investment) calculator by providing essential details such as the project name, applicable countries, primary and additional currencies, and the default language. Users can also choose layout templates for various stages of the calculator including the landing page, user profiling, input form, savings summary, value-add details, and the final savings report, with the option to select vertical or horizontal orientation for the downloadable report. Once all inputs are provided, clicking the Continue button adds the ROI calculator and proceeds to the next step in the setup process, where users can further customize the calculator’s content, logic, and visuals.
                </p>

                <div className="card dashboard-card mb-4">
                  <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                    User Guide: Create New ROI Calculator
                  </div>
                  <div className="card-body">
                    <p> <b>Create ROI Calculator</b>   </p>
                    <ul>
                      <li> Click on the "Create " button to initiate the process of creating a new
                        ROI Calculator from “ROI Calculatorˮ page</li>
                      <img src={image001} alt="Create New Calculator" className='img-fluid pt-10 pb-20' />
                    </ul>
                    <p> <b> Step 2: Project Name</b>   </p>
                    <ul>
                      <li>  Purpose: Enter a descriptive name for your ROI calculator project. This is required field</li>
                      <img src={image002} alt="Project Name" className='img-fluid  pt-10 pb-20' />
                    </ul>
                    <p> <b> Applicable Countries</b>   </p>
                    <ul>
                      <li> Select one or more countries where the calculator will be used. This field is also mandatory
                      </li>
                      <img src={image003} alt="Applicable Countries" className='pt-10 pb-20' />
                    </ul>
                    <p> <b> Primary Currency  </b>   </p>
                    <ul>
                      <li> Define the main currency used in calculations. This field is also mandatory
                      </li>
                      <img src={image004} alt="Number of Sections" className='pt-10 pb-20' />
                    </ul>

                    <p> <b> Additional Currencies</b>   </p>
                    <ul>
                      <li>  Purpose: Add any secondary currencies you'd like the calculator to support.
                        Input Type is  multi-select Dropdown
                      </li>

                      <img src={image005} alt="Currencies" className='pt-10 pb-20' />
                    </ul>

                    <p> <b> Default Language</b>   </p>
                    <ul>
                      <li>  Purpose: Choose the language that will be displayed by default in the calculator interface. This field is also mandatory
                      </li>

                      <img src={image006} alt="Select language" className='pt-10 pb-20' />
                    </ul>

                    <p> <b>  Landing Page</b>   </p>
                    <ul>
                      <li>  A quick overview of the calculator's purpose with a CTA button to start. Choose one layout.
                      </li>

                      <img src={image007} alt="Landing Page" className='pt-20 pb-20' />
                    </ul>

                    <p> <b>  User Profiling</b>   </p>
                    <ul>
                      <li>  Collects basic information about the user's business or situation. This helps in customizing results.
                      </li>

                      <img src={image008} alt="User Profiling" className='pt-10 pb-20' />
                    </ul>

                    <p> <b>  User Input Form</b>   </p>
                    <ul>
                      <li>  Form to collect numeric or text data from users. Can be single-scrollable or multi-step with logic conditions.
                      </li>

                      <img src={image009} alt="User Input Form" className='pt-10 pb-20' />
                    </ul>

                    <p> <b> Savings Summary</b>   </p>
                    <ul>
                      <li>  Displays estimated savings using Vodafone’s solution (annually or over 3 years).
                      </li>

                      <img src={image010} alt="Savings Summary" className='pt-10 pb-20' />
                    </ul>

                    <p> <b>  Value-add Details</b>   </p>
                    <ul>
                      <li>  Provides a detailed cost breakdown including assumptions, user inputs, and adjustable figures.
                      </li>

                      <img src={image011} alt="Value-add Details" className='pt-10 pb-20' />
                    </ul>

                    <p> <b>  Savings Report</b>   </p>
                    <ul>
                      <li>  Select the report format to generate a downloadable summary of the results:
                        Vertical/ Horizontal
                        Only one option can be selected.
                      </li>

                      <img src={image012} alt="Manage Survey" className='pt-10 pb-20' />
                    </ul>

                    <p> <b>  Report Orientation Type</b>   </p>
                    <ul>
                      <li>  Choose this to offer a detailed downloadable report, which shows calculated savings and specifics. You can also showcase your solution and add links to relevant resources. You can customise the report's content in the next step.
                      </li>

                      <img src={image013} alt="Report Orientation " className='pt-10 pb-20' />
                    </ul>
                    <p> <b>  Blank Page</b>   </p>
                    <ul>
                      <li>  Start from scratch with a fully customizable blank page. Ideal for creating unique content, adding visuals, or embedding custom messages.
                        You have complete control over the layout and design in the next step.
                        This suggests you’re choosing a blank template to build a page from scratch.
                      </li>

                      <img src={image015} alt="Report Orientation " className='pt-10 pb-20' />
                    </ul>
                    <p> <b>  Decimal Value Support</b>   </p>
                    <ul>
                      <li>  This means you're choosing whether the calculator you're setting up will allow numbers like 3.14 or just whole numbers like 3
                      </li>

                      <img src={image016} alt="Report Orientation " className='pt-10 pb-20' />
                    </ul>
                    <p> <b>  Final Step</b>   </p>
                    <ul>
                      <li>  Cancel – Aborts the setup.
                      </li>
                      <li>Continue – Saves your configuration and proceeds to the next step. Upon clicking the Continue button:

                        One new ROI Calculator has been successfully added.

                      </li>
                      <img src={image014} alt="buttons" className='pt-10 pb-10' />
                    </ul>

                  </div>
                </div>

              </div>

            </div>
          </div>

        </div>
      </div>
    </>
  )
}
